import ProjectName from './ProjectName';
import WebsiteAddress from './WebsiteAddress';
import WhitePaper from './WhitePaper';
import Explainer from './Explainer';
import Video from './Video';
import Telegram from './Telegram';
// import Discord from './Discord';
import XAccount from './XAccount';
import SubmitYourApplication from './SubmitYourApplication';

type Step = {
  stepId: number;
  component: JSX.Element;
  progressOnMount: number;
};

export const steps: Step[] = [
  {
    stepId: 0,
    component: <ProjectName />,
    progressOnMount: 0.125,
  },
  {
    stepId: 1,
    component: <WebsiteAddress />,
    progressOnMount: 0.25,
  },
  {
    stepId: 2,
    component: <WhitePaper />,
    progressOnMount: 0.325,
  },
  {
    stepId: 3,
    component: <Explainer />,
    progressOnMount: 0.5,
  },
  {
    stepId: 4,
    component: <XAccount />,
    progressOnMount: 0.625,
  },
  {
    stepId: 5,
    component: <Telegram />,
    progressOnMount: 0.75,
  },
  // {
  //   stepId: 6,
  //   component: <Discord />,
  //   progressOnMount: 0.77,
  // },
  {
    stepId: 6,
    component: <Video />,
    progressOnMount: 0.875,
  },
  {
    stepId: 7,
    component: <SubmitYourApplication />,
    progressOnMount: 1,
  },
];

export const getStepById = (stepId: number): Step | undefined =>
  steps.find((step) => step.stepId === stepId);
